import { Box, Checkbox, FormControlLabel, Stack } from '@common-components';
import { FileType, PlacementType } from 'enums';
import { messages } from 'i18n';

import useSubmissionWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import CompareQuotesFilesBucketAction from './CompareQuotesFilesBucketAction';
import FilesBucket from './FilesBucket';

interface FilesViewerProps {
  shouldRedactCommission: boolean;
  onRedactCommissionChange: (checked: boolean) => void;
}

export default function FilesViewer({ shouldRedactCommission, onRedactCommissionChange }: FilesViewerProps) {
  const { submission } = useSubmissionWorkspace();
  const { filesStep } = messages.submissionWorkspace.tabs.proposal;

  return (
    <Stack>
      <Box height={1} overflow="hidden" py={1} px={6} sx={{ position: 'relative', overflowY: 'auto' }}>
        <Stack height={1} maxWidth={640} mx="auto">
          <Stack gap={6}>
            {submission?.placementType === PlacementType.Wholesaler && (
              <FilesBucket fileType={FileType.CapitolaQuote} />
            )}
            <FilesBucket fileType={FileType.QuoteComparison} component={<CompareQuotesFilesBucketAction />} />
            <FilesBucket fileType={FileType.MarketingReport} />
            <FilesBucket />
          </Stack>
          <FormControlLabel
            control={
              <Checkbox checked={shouldRedactCommission} onChange={(e) => onRedactCommissionChange(e.target.checked)} />
            }
            label={filesStep.redactCommissionLabel}
          />
        </Stack>
      </Box>
    </Stack>
  );
}
